export enum LOCAL_STORAGE {
  CONFIGURED_VIEWS = 'configuredViews',
}
